import { MdPivotTableChart } from "react-icons/md";

const getDataFieldsPivotTable = () => {
  return [
    {
      title: "Rows",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "rows",
      itemInArray: true,
    },
    {
      title: "Values",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Columns",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Row Limit",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 500,
      valueType: "Number",
      canEdit: true,
    },
  ];
};

const getCustomizationFieldPivotTable = () => {
  return [
    {
      title: "Row Total",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isRowTotalVisible",
    },
    {
      title: "Column Total",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isColumnTotalVisible",
    },
    {
      title: "Measure On Top",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isMeasureOnTop",
    },
    {
      title: "Custom Alignmant",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isCustomAlign",
      innerComponents: [
        {
          title: "Row Align",
          type: "textAlign",
          reduxKey: "rowAlign",
          defaultValue: "left",
        },
        {
          title: "Value Align",
          type: "textAlign",
          reduxKey: "valueAlign",
          defaultValue: "center",
        },
      ],
    },
    {
      title: "Table Head",
      type: "CONTAINER_WITHOUT_TOGGLE",
      innerComponents: [
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: true,
          reduxKey: "isPivotHeadBold",
          isParent: true,
        },
        {
          title: "Head Font Color",
          type: "fontColor",
          defaultValue: "#374151",
          reduxKey: "pivotHeadFontColor",
        },
        {
          title: "Head Background Color",
          type: "fontColor",
          defaultValue: "#e5e7eb",
          reduxKey: "pivotHeadBgColor",
        },
      ],
    },
    {
      title: "Conditional Formatting",
      type: "CONDITIONAL_FORMATTING",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "conditionalFormatting",
      itemInArray: true,
      defaultValue: [],
    },
  ];
};
const getPivotTableChartDetails = () => {
  return {
    chartType: "recharts",
    imageSrc: "/graph_img/PivotTable.png",
    label: "Pivot Table",
    value: "simpleTable",
    icon: <MdPivotTableChart className="text-xl text-blue-950" />,
    fileName: "PivotTable.js",
  };
};
export {
  getDataFieldsPivotTable,
  getCustomizationFieldPivotTable,
  getPivotTableChartDetails,
};
